export default __webpack_public_path__ + "static/media/Manual_Programa_de_Excelência_Cargill_PEC_2026.5285bc2d.pdf";